import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import lodashAssign from 'lodash/assign';
var STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPTED: 202
};

function responseHandler(resolve, reject) {
  return function (err, resp, data) {
    if (!err && (STATUS_CODES.SUCCESS === resp.statusCode || STATUS_CODES.CREATED === resp.statusCode || STATUS_CODES.ACCEPTED === resp.statusCode)) {
      resolve({
        resp: resp,
        data: data
      });
    } else {
      reject({
        err: err,
        resp: resp,
        data: data
      });
    }
  };
}

export default function pollingContinue(http, apiRequest, timeout, pollingTime, pollingStartTime, pollingData) {
  return new Promise(function (resolve, reject) {
    var newRequest = lodashAssign({}, apiRequest, {
      callback: responseHandler(resolve, reject)
    }); // Change the body of the request to what was returned from the previous call
    // i.e. this would contain some kind of job id for polling

    if (pollingData) newRequest.body = pollingData;
    return http(newRequest);
  }).then(function (promise) {
    // default, but should never happen because we should always call this client side
    var now = Date.now();
    var resp = promise.resp;
    var data = promise.data;
    var currentStatusCode = resp.statusCode;

    if (typeof window !== 'undefined') {
      // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
      now = window.performance.now();
    }

    if (now > pollingStartTime + timeout) {
      return apiRequest.callback('Polling timeout', resp, data);
    } // A success status means polling is done and call original callback


    switch (currentStatusCode) {
      case STATUS_CODES.SUCCESS:
        return apiRequest.callback(null, resp, data);

      case STATUS_CODES.CREATED:
      case STATUS_CODES.ACCEPTED:
        return setTimeout(function () {
          pollingContinue(http, apiRequest, timeout, pollingTime, pollingStartTime, data);
        }, pollingTime);

      default:
        return apiRequest.callback('Not a valid response', resp, data);
    }
  }).catch(function (promise) {
    apiRequest.callback(promise.err, promise.resp, promise.data);
  });
}